<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  conflict: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm', 'correct', 'edit']);
const { t } = useI18n();
const resolved = computed(() => props.conflict.resolution !== 'pending');
const value = item => item || t('SALES.DELIVERY.ANALYSIS.EMPTY_VALUE');
</script>

<template>
  <article class="rounded-lais-sm border border-lais-border-soft bg-white p-4">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <p class="font-semibold text-lais-text">{{ conflict.label }}</p>
        <p class="mt-1 text-xs text-lais-text-muted">{{ conflict.field }}</p>
      </div>
      <span
        class="rounded-full px-2 py-1 text-xs font-bold"
        :class="
          resolved
            ? 'bg-emerald-50 text-emerald-700'
            : 'bg-amber-50 text-amber-800'
        "
      >
        {{
          resolved
            ? t('SALES.DELIVERY.ANALYSIS.RESOLVED')
            : t('SALES.DELIVERY.ANALYSIS.PENDING')
        }}
      </span>
    </div>
    <dl class="mt-4 grid gap-3 text-sm sm:grid-cols-2">
      <div class="rounded-lais-sm bg-lais-bg-soft p-3">
        <dt class="text-xs font-bold uppercase text-lais-text-muted">
          {{ t('SALES.DELIVERY.ANALYSIS.RECEIPT_VALUE') }}
        </dt>
        <dd class="mt-1 text-lais-text">{{ value(conflict.receipt_value) }}</dd>
      </div>
      <div class="rounded-lais-sm bg-lais-bg-soft p-3">
        <dt class="text-xs font-bold uppercase text-lais-text-muted">
          {{ t('SALES.DELIVERY.ANALYSIS.REGISTERED_VALUE') }}
        </dt>
        <dd class="mt-1 text-lais-text">
          {{ value(conflict.registered_value) }}
        </dd>
      </div>
    </dl>
    <div v-if="!resolved" class="mt-4 flex flex-wrap gap-2">
      <button
        type="button"
        class="rounded-lais-sm border border-lais-border px-3 py-2 text-sm font-semibold text-lais-text"
        :disabled="disabled || loading"
        @click="emit('edit', conflict)"
      >
        {{ t('SALES.DELIVERY.ANALYSIS.EDIT') }}
      </button>
      <button
        type="button"
        class="rounded-lais-sm bg-lais-primary px-3 py-2 text-sm font-semibold text-white disabled:opacity-60"
        :disabled="disabled || loading"
        @click="emit('confirm', conflict)"
      >
        {{ t('SALES.DELIVERY.ANALYSIS.CONFIRM') }}
      </button>
      <button
        type="button"
        class="rounded-lais-sm border border-lais-primary px-3 py-2 text-sm font-semibold text-lais-primary disabled:opacity-60"
        :disabled="disabled || loading"
        @click="emit('correct', conflict)"
      >
        {{ t('SALES.DELIVERY.ANALYSIS.CORRECTED') }}
      </button>
    </div>
  </article>
</template>
